import React from 'react';
import { connect } from 'dva';
import ABSNoContent from '../../../../../components/ABSNoContent';
import { Player } from 'video-react';
import 'video-react/dist/video-react.css'; 
import { ABSModal } from '../../../../../components/ABSModal';
import ABSImage from '../../../../../components/ABSImage';
import ABSLink from '../../../../../components/ABSLink';
import ABSCarousel from '../../../../../components/ABSCarousel';

export interface IAdvertisementBannerProps {
  dispatch?: any;
  advertisementsData?: any;
}

export interface IAdvertisementBannerState {
  videoSource: string;
}

class AdvertisementBanner extends React.Component<IAdvertisementBannerProps, IAdvertisementBannerState> {
  modal;
  player;
  videoSrc;

  constructor(props: any) {
    super(props);
    this.state = {
      videoSource: ''
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'home/getHomePageAdvertisement',
      payload: { count: 10 }
    });
  }
  openVideoModal = (index: number) => {
    const { advertisementsData } = this.props;
    const adData = advertisementsData[index];
    this.modal.show( true, () => {
      const time = setInterval(() => {
        if (this.player) {

          if (this.videoSrc === adData.videoUrl) {
            this.player.play();
          } else {
            this.setState({
              videoSource: adData.videoUrl
            });
            this.player.load();
            this.videoSrc = adData.videoUrl;
          }
          clearInterval(time);
        }
      }, 500);
    });
  }
  closeVideo = () => {
    this.player.replay(1000);
    this.player.pause();
  }
  renderVideo = () => {
    const { videoSource } = this.state;
    return (
      <Player fluid={false} height="100%" width="100%" preload="auto" autoPlay={true} ref={player => this.player = player}>
        <source src={videoSource} />
      </Player>
    );
  }

  AdvertisementBanner = (adData: any, index: number) => {
    const playImgSrc = require('../../../../../assets/images/play.png');
    
    return (
      <div className="abs-home-advertisement-banner-content" key={index}>
        <div style={{ backgroundImage: `url(${adData.imageUrl}?w=1280)`, width: '100%', height: '100%'}}>
          {adData.type === 3 ?
            <ABSImage logo={playImgSrc} width={84} height={84} className="abs-player-btn" onClick={() => this.openVideoModal(index)} />
            : 
            (
              adData.linkUrl ? 
                <ABSLink
                  to={adData.linkUrl}
                  children=""
                  className="abs-home-advertisement-banner-content-link"
                /> : null
            )
        }
        </div>
      </div>
    );
  }

  renderAdvertisementContent() {
    const { advertisementsData } = this.props;
    return advertisementsData.map((item, index) => {
      return this.AdvertisementBanner(item, index);
    });
  }

  render() {
    const { advertisementsData } = this.props;
    if (!advertisementsData || advertisementsData.length === 0) {
      return <ABSNoContent />;
    }
    return (
      <div className="abs-home-advertisement-banner">
        <ABSCarousel autoplaySpeed={5000}>
          {this.renderAdvertisementContent()}
        </ABSCarousel>
        <ABSModal
          wrapClassName="abs-home-page-video-modal"
          content={this.renderVideo()}
          width={948}
          footer={null}
          ref={view => this.modal = view}
          onClose={this.closeVideo}
        />
      </div>
    );
  }
}

function mapStateToProps({ home, global, loading }: any) {
  const { advertisementsData } = home;
  return { advertisementsData };
}

export default connect(mapStateToProps)(AdvertisementBanner);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/middle/AdvertisementBanner.tsx